import { observable } from "mobx";
import { Type } from "class-transformer";
import AdHocReportRequestResponse from "./adhocReportRequestResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CreateAdHocReportRequestResponse {
  @observable
  @Type(() => AdHocReportRequestResponse)
  createdAdHocReportRequest?: AdHocReportRequestResponse;

  @observable
  existingReportId?: string;
}
